<template>
    <div class="logo" @click="navTo">
        <img :src="props.state ? topImgExpanded : topImgCollapsed" :class="{'logo-collapsed': !props.state}" alt="Logo"/>
    </div>
</template>

<script setup>
import {computed, defineProps} from 'vue'
import {useRouter} from "vue-router";
import {useStore} from "vuex";

const router = useRouter()
const store = useStore()
const props = defineProps({
    state: {
        type: Boolean,
        default: true,
    }
})

const topImgExpanded = computed(() => store.getters.getCustomInformation.logoImg)
const topImgCollapsed = computed(() => store.getters.getCustomInformation.logoSmallImg)

const navTo = () => {
    router.push('/home')
}

</script>

<style lang="scss" scoped>
@import './scss/logo.scss';
</style>
